export const DASHBOARD_PARAMETERS = {
    LOGOUT_CALLBACK: 'logoutTrigger',
    SYNC_TRIGGER_CALLBACK: 'syncTrigger',
    CHECK_SESSION_CALLBACK: 'checkAndGetSessionStatus',
    APPLICATION_SPECIFIC_CALLBACKS: 'applicationSpecificCallbacks',
    GET_PRESUMED_RESULT_SOURCE_DETAILS_CALLBACK: 'getPresumedResultSourceDetails',
    CREATE_PRESUMED_RESULT_CALLBACK: 'createPresumedResult',
    DELETE_PRESUMED_RESULT_CALLBACK: 'deletePresumedResult',
    RELOAD_PAGE_CALLBACK: 'reloadPage',
    APPLICATIONS_PARAM: 'applications',
    STAFF_PARAM: 'staff',
    INSTITUTION_PARAM: 'institution',
    CLASSES_PARAM: 'classes',
    CLASSES_STUDENTS_PARAM: 'classesStudents',
    IS_DEVICE_SUPPORTED_PARAM: 'isDeviceSupported',
    FORMS_PARAM: 'forms',
    IS_UNSYNCED_DATA_PARAM: 'isUnsyncedData',
    IS_SYNC_SUCCESS_PARAM: 'isSyncSuccess',
    EDITION_CONFIG: 'edition',
    GATING_RULES_CONFIG: 'gatingRulesConfig',
    BM_WINDOW_CONFIG: 'bmWindowConfig',
    BENCHMARK_WINDOWS_PARAM: 'benchmarkWindows',
    FEATURE_TOGGLE_PARAM: 'featureToggle',
    FLO_PM_LINK: 'floPMPopupLink',
    IS_BROWSER_SUPPORTED: 'isBrowserSupported',
    IS_SECURE_ASSESSMENTS_ENABLED: 'isSecureAssessmentsEnabled',
};
